import { Module } from '@nestjs/common';
import { ConfigModule } from '@nestjs/config';
import { APP_GUARD } from '@nestjs/core';
import { ThrottlerGuard, ThrottlerModule } from '@nestjs/throttler';
import { LoggerModule } from 'nestjs-pino';
import { AuthModule } from '../auth/auth.module';
import { CatalogModule } from '../catalog/catalog.module';
import { OperationsModule } from '../operations/operations.module';
import { PrismaModule } from '../prisma/prisma.module';
import { SecurityModule } from '../security/security.module';
import { SettingsModule } from '../settings/settings.module';
import { TransactionsModule } from '../transactions/transactions.module';

function validateConfig(
  config: Record<string, unknown>,
): Record<string, unknown> {
  const databaseUrl = String(config['DATABASE_URL'] ?? '');
  const postgresPassword = String(config['POSTGRES_PASSWORD'] ?? '');
  const hasPostgresConfig =
    String(config['POSTGRES_HOST'] ?? '').length > 0 &&
    String(config['POSTGRES_DB'] ?? '').length > 0 &&
    String(config['POSTGRES_USER'] ?? '').length > 0 &&
    postgresPassword.length > 0;
  const jwtSecret = String(config['JWT_ACCESS_SECRET'] ?? '');
  if (!databaseUrl.startsWith('postgres') && !hasPostgresConfig) {
    throw new Error(
      'Configure PostgreSQL using POSTGRES_HOST, POSTGRES_DB, POSTGRES_USER, and POSTGRES_PASSWORD',
    );
  }
  if (jwtSecret.length < 32) {
    throw new Error('JWT_ACCESS_SECRET must contain at least 32 characters');
  }
  return config;
}

@Module({
  imports: [
    ConfigModule.forRoot({
      isGlobal: true,
      cache: true,
      validate: validateConfig,
    }),
    LoggerModule.forRoot({
      pinoHttp: {
        level: process.env['LOG_LEVEL'] ?? 'info',
        redact: [
          'req.headers.authorization',
          'req.body.password',
          'req.body.refreshToken',
        ],
        autoLogging: true,
      },
    }),
    ThrottlerModule.forRoot([
      {
        ttl: Number(process.env['RATE_LIMIT_WINDOW_MS'] ?? 60_000),
        limit: Number(process.env['RATE_LIMIT_MAX'] ?? 120),
      },
    ]),
    PrismaModule,
    AuthModule,
    SecurityModule,
    SettingsModule,
    CatalogModule,
    TransactionsModule,
    OperationsModule,
  ],
  providers: [{ provide: APP_GUARD, useClass: ThrottlerGuard }],
})
export class AppModule {}
